// frontend/src/hooks/useHashSession.js

export function clearStoredSession() {
   sessionStorage.removeItem('hashSession');
}

export function getStoredSession() {
  return JSON.parse(sessionStorage.getItem('hashSession'));
}

export function setStoredSession(
  hash,
  role,
  parentHash = null,
  groupName = null,
  ownerName = null,
  state = null
) {
  const session = { hash, role }

  if (parentHash) session.parentHash = parentHash
  if (groupName) session.groupName = groupName
  if (ownerName) session.ownerName = ownerName
  if (state) session.state = state

  sessionStorage.setItem('hashSession', JSON.stringify(session))
}